import { RoleHost } from '../RoleHost';

export function LBWrapper() {
  return <RoleHost role="lb" />;
}
